import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import BinaryImageForm from './BinaryImageForm';
import * as Yup from 'yup';
import * as actions from "./store/binaryImageActions";
import History from '../../../History';
import { withStyles, CircularProgress, Dialog, Typography } from "@material-ui/core";
import { hasPermission, hexToDec, isValidHex } from '../../sc-utilities';
import { CancelToken } from 'axios';
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: "auto",
        paddingTop: theme.spacing(),
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down("sm")]: {
            padding: 0,
            margin: 0,
            width: "100%"
        }
    },
    paper: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    typographyTo: {
        marginTop: "5px",
        color: theme.palette.buttonText.default,
    },
    typography: {
        marginTop: "5px",
        color: theme.palette.buttonText.default,
        position: "absolute",
        top: "40%",
        right: "0",
        textAlign: "center",
        left: "0"
    },
    dialog: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    l: {
        width: "250px",
        margin: "10px"
    }
});

const BinaryImageCreate = props => {
    const { classes, activeCustomerID, translations, permissions, onCreateBinaryImage, onFetchBinaryImageTypes, onClearState, binaryImages, customers } = props;
    const [fileToSend, setFileToSend] = useState({ fileToSend: {}, fileName: '' });
    const [createData, setCreateData] = useState({ binaryImageTypes: [], loadingData: true });

    const handleUpload = event => {
        let file = event[0];
        if (!file) {
            setFileToSend({ fileToSend: {}, fileName: '' });
            return
        }
        setFileToSend({ fileToSend: file, fileName: file.name, imageValue: URL.createObjectURL(file) });
    };

    const handleSubmit = async dataForm => {
        const data = new FormData();
        data.append("File", fileToSend.fileToSend);
        data.append("FileName", fileToSend.fileName);
        data.append("MajorVersion", dataForm.MajorVersion);
        data.append("MinorVersion", dataForm.MinorVersion);
        data.append("BuildNumber", dataForm.BuildNumber);
        data.append("BinaryImageTypeID", dataForm.BinaryImageTypeID);
        data.append("Name", dataForm.Name);
        data.append("BuildType", dataForm.BuildType);
        data.append("Public", dataForm.Public === "yes" ? true : false);
        data.append("Severity", dataForm.Severity);
        data.append("ReleaseNotes", dataForm.ReleaseNotes);
        data.append("ActiveCustomerID", activeCustomerID);
        data.append("Type", dataForm.Type);
        data.append("URL", dataForm.Type === 'Internal' ? null : dataForm.URL);

        if (dataForm?.Type?.includes('External')) {
            data.append("CRC", hexToDec(dataForm.CRC));
        }

        if (dataForm.Public === "no") {
            data.append("CustomerID", dataForm.CustomerID);
        }
        let token = localStorage.getItem("SESSION");

        data.append("Token", token);
        let result = await onCreateBinaryImage(data);
        if (result) {
            History.goBack();
        }
    }

    useEffect(() => {
        const requestToken = CancelToken.source();
        const fetchBinaryImageTypes = async () => {
            let binaryImageTypes = await onFetchBinaryImageTypes(activeCustomerID, { CancelToken: requestToken.token });
            setCreateData({ binaryImageTypes: binaryImageTypes, loadingData: false });
        };
        fetchBinaryImageTypes();
        return () => {
            onClearState()
            requestToken.cancel('Operation canceled by the user.');
        };
    }, [onFetchBinaryImageTypes, activeCustomerID, onClearState]);

    let initialValues = {
        MajorVersion: '',
        MinorVersion: '',
        BuildNumber: '',
        BinaryImageTypeID: '',
        Name: '',
        BuildType: 'prod',
        Public: 'yes',
        Severity: '2',
        ReleaseNotes: '',
        Type: 'Internal',
        URL: '',
        CRC: '',
        CustomerID: ''
    };

    let formSettings = {
        Validation: {
            MajorVersion: Yup.number().required("Required"),
            MinorVersion: Yup.number().required("Required"),
            BuildNumber: Yup.number().required("Required"),
            BinaryImageTypeID: Yup.string().required('Required'),
            Name: Yup.string().required("Required"),
            Type: Yup.string().required('Required'),
            URL: Yup.string().when("Type", {
                is: val => val.includes('External'),
                then: Yup.string().required('Required')
            }),
            CRC: Yup.string().when("Type", {
                is: val => val.includes('External'),
                then: Yup.string().required('Required').test('hex', 'Is not a valid hexadecimal number.', crc => isValidHex(crc))
            }),
            CustomerID: Yup.string().when("Public", {
                is: val => (val === 'no'),
                then: Yup.string().required('Required')
            })
        },
        FormTitle: translations["create_new_software"] || "Create new software",
        ButtonSubmit: hasPermission(permissions, 'binary_image_create') ? {
            Title: translations["save"] || "SAVE"
        } : null,
    };
    return (
        !createData.loadingData ?
            (
                <div>
                    <BinaryImageForm
                        binaryImageType={createData.binaryImageTypes}
                        formSettings={formSettings}
                        initialValues={initialValues}
                        handleSubmit={handleSubmit}
                        handleUpload={handleUpload}
                        loading={!fileToSend.fileName}
                        translations={translations}
                        customers={customers}
                    />
                    <Dialog
                        disableBackdropClick={true}
                        disableEscapeKeyDown={false}
                        open={binaryImages.creating}
                        PaperProps={{
                            classes: {
                                root: classes.paper
                            }
                        }}
                    >
                        <div style={{ marginBottom: "1px", position: "relative" }}>
                            <CircularProgress
                                variant="static"
                                color="primary"
                                style={{ marginBottom: "10px" }}
                                size={300}
                                value={binaryImages.progress ? binaryImages.progress : 0}
                            />
                            <Typography
                                className={classes.typography}
                                variant="h4"
                            >
                                {" "}
                                {binaryImages.progress ? binaryImages.progress : 0}%{" "}
                            </Typography>
                            <br></br>
                        </div>
                        <Typography variant="h5" className={classes.typographyTo}
                        >
                            Please do not refresh THIS page. Uploading {binaryImages.loadSize ? binaryImages.loadSize : 0} / {binaryImages.maxSize ? binaryImages.maxSize : 0}MB
                </Typography>
                    </Dialog>
                </div>) :
            (
                <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={createData.loadingData}
                    PaperProps={{
                        classes: {
                            root: classes.dialog
                        }
                    }}
                >
                    <AppLogoLoading />
                </Dialog>
            )
    )
};

const mapStateToProps = state => {
    return {
        binaryImages: state.exportImport.binaryImages,
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || [],
        customers: state?.core?.login?.customers || []
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onFetchBinaryImageTypes: (activeCustomerID, options) => dispatch(actions.listBinaryImageTypes(activeCustomerID, options)),
        onCreateBinaryImage: data => dispatch(actions.createNewBinaryImage(data)),
        onClearState: () => dispatch(actions.ClearStateCreate()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(BinaryImageCreate));